import { parseAmount, parseAmountCents } from '../money';
import { UserInputOffer } from './negotiation_types';

export function offerSubtotal(
  offer: UserInputOffer,
  currency: string,
) {
  const priceAmountCents = parseAmount(offer.price, currency).amountCents;
  const { quantity } = offer;

  const subtotalAmountCents = priceAmountCents * quantity;
  return parseAmountCents(subtotalAmountCents, currency);
}

export function offerTotal(
  offer: UserInputOffer,
  currency: string,
) {
  const shippingPriceAmountCents = parseAmount(offer.shippingPrice, currency).amountCents;
  const subtotalAmountCents = offerSubtotal(offer, currency).amountCents;
  const totalAmountCents = subtotalAmountCents + shippingPriceAmountCents;

  return parseAmountCents(totalAmountCents, currency);
}
